import { createContext } from 'react'

// ============================================================================
// Module-scope constants (never re-created on render)
// ============================================================================

/** Default canvas config for CanvasDropZone — hoisted to avoid inline object re-creation */
export const CANVAS_DROP_ZONE_CONFIG = {
  grid: {
    visible: true,
    enableSnap: true,
    baseSize: 20,
    baseDotSize: 1.2,
    renderMode: 'lines' as const,
    showCrosshair: false,
  },
  nodes: {
    enableDrag: true,
    enableSelect: true,
  },
} as const

// Canvas viewport context for drag preview scaling
export const CanvasViewportContext = createContext<{ zoom: number }>({ zoom: 0.5 })
